module.exports = __webpack_public_path__ + "static/media/add-user.76c44090.svg";